import React from 'react';
import { Typography, Box, Button } from '@mui/material';
import Layout from './Layout';
import { errorConfig } from '../utils/errorConfig';

export type ErrorKey = keyof typeof errorConfig;

type ErrorProps = {
  error: unknown;
  onRetry?: () => void;
  useLayout?: boolean; // new prop to toggle layout
};

const getErrorType = (error: unknown): ErrorKey => {
  if (!error) return 'unknown';

  const err = error as any;
  const status = err?.response?.status;

  if (status && errorConfig[status as ErrorKey]) {
    return status as ErrorKey;
  }

  const message = (err?.message || '').toLowerCase();

  if (message.includes('network')) return 'network';
  if (err?.code === 'ECONNABORTED' || message.includes('timeout')) return 'timeout';
  if (message.includes('parse')) return 'parse';
  if (status === 401 || message.includes('auth')) return 'auth';

  return 'unknown';
};

const ErrorComponent: React.FC<ErrorProps> = ({ error, onRetry, useLayout = true }) => {
  console.log('error',error)
  const errorType = getErrorType(error);
  const { title, message, image } = errorConfig[errorType] || errorConfig['unknown'];

  const content = (
    <Box
      textAlign="center"
      mt={5}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={2}
    >
      <img
        src={image}
        alt={title}
        style={{ width: '250px', maxWidth: '100%', borderRadius: 8 }}
      />
      <Typography variant="h4" color="error" sx={{ mt: 2 }}>
        {title}
      </Typography>
      <Typography variant="body1" sx={{ mt: 1, maxWidth: 500 }}>
        {message}
      </Typography>

      {onRetry && (
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 3 }}
          onClick={onRetry}
        >
          Retry
        </Button>
      )}
    </Box>
  );

  // Conditionally wrap with Layout
  return useLayout ? <Layout>{content}</Layout> : content;
};

export default ErrorComponent;
